import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const PersonalityStyles = styled(OnboardingPage)`
  .personality-title {
    margin: 8px 0 24px;
  }

  ion-content {
    &::part(scroll) {
      padding: 0 24px;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .range-data {
      width: 100%;
      flex: 0;
      padding: 0 4px;
      border-radius: 8px;

      --bar-background: #78788029;
      --bar-background-active: #c6399a;
      --bar-height: 8px;
      --bar-border-radius: 8px;
      --knob-background: linear-gradient(95.02deg, #c6399a 0%, #4904aa 100%);
      --knob-size: 28px;
      --pin-background: none;
      --pin-color: none;
      transition: all 0.2s;
    }

    .range-labels {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0;
      gap: 8px;
    }
  }
`;
